import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { NonExchangeDay, defaultNonExchangeDay } from '../../../app/models/NonExchangeDay';
import NonExchangeDayForm from './forms/NonExchangeDayForm';
import useNonExchangeDayService from '../../../app/services/hooks/useNonExchangeDayService';
import { Currency } from '../../../app/models/Currency';

interface Props {
    nonExchangeDayId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const NonExchangeDayEdit = ({ nonExchangeDayId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [errorGetData, setErrorGetData] = useState('');
    const [nonExchangeDayDataForm, setNonExchangeDayDataForm] = useState<NonExchangeDay>(defaultNonExchangeDay);
    const [errorFields, setErrorFields] = useState<any>();
    const [currencies, setCurrencies] = useState<Currency[]>([]);

    const { editNonExchangeDay, fetchingEditNonExchangeDay, updateNonExchangeDay, fetchingUpdateNonExchangeDay } = useNonExchangeDayService();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        editNonExchangeDay(nonExchangeDayId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setNonExchangeDayDataForm(response.data.non_exchange_day);
                setCurrencies(response.data.currencies);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                setErrorGetData(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(response.data);
            }
        });
    };

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando...');
            updateNonExchangeDay(nonExchangeDayId, nonExchangeDayDataForm, {
                onSuccess: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    toast.success('día de no cambio actualizado correctamente');
                    if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                setErrorFields(response.data.errors);
                if (onError) onError();
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <NonExchangeDayForm
                        nonExchangeDayDataForm={nonExchangeDayDataForm}
                        setNonExchangeDayDataForm={setNonExchangeDayDataForm}
                        errorFields={errorFields} currencies={currencies}                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingUpdateNonExchangeDay} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingUpdateNonExchangeDay} />
                </div>
            </div>
        </>
    );
};

export default NonExchangeDayEdit; 